import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ApiErrorException } from '@/api/client';
import { toUserMessage } from '@/lib/errorToast';

/**
 * SU-1 (W7): the organisation lifecycle and impersonation error codes,
 * translated (fr/en, admin:organisations.lifecycle.errors); anything else as
 * the shared error toast says it. Small on purpose: the impersonation banner
 * (dialer and portal) uses it without loading the back-office menu.
 */
const LIFECYCLE_CODES = [
  'ORGANISATION_DISABLED', 'IMPERSONATION_READ_ONLY', 'IMPERSONATION_SUPER_ADMIN_TARGET', 'IMPERSONATION_NO_SUBJECT',
  'CONFIRM_NAME_MISMATCH', 'LAST_ADMIN_OF_ORGANISATION', 'EMAIL_UNAVAILABLE', 'USER_ALREADY_EXISTS',
];

export function useLifecycleError() {
  const { t } = useTranslation(['admin']);
  const message = (err: unknown): string => {
    const code = err instanceof ApiErrorException ? err.code : (err as { code?: string } | null)?.code;
    return code && LIFECYCLE_CODES.includes(code) ? t(`admin:organisations.lifecycle.errors.${code}`) : toUserMessage(err);
  };
  return { message, notify: (err: unknown) => { toast.error(message(err)); } };
}
